import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=e4ae416a&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ae416a')) {
      api.createRecord('e4ae416a', component.options)
    } else {
      api.reload('e4ae416a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=e4ae416a&", function () {
      api.rerender('e4ae416a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/categories/edit.vue"
export default component.exports